var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"h3"},[_vm._v("Puan Özetim")]),_c('point-details'),_c('div',{attrs:{"id":"grid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }